export const amountFormatter = (value : any) => {
    let amountValue = Number(value)
    let val : any = Math.abs(amountValue)
    if (val >= 10000000) {
      val = (val / 10000000).toFixed(2) + ' Cr';
    } else if (val >= 100000) {
      val = (val / 100000).toFixed(2) + ' L';
    }
    return val;
  }